<template>
  <span :class="className">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      viewBox="0 0 48 48"
      v-if="icon === 'play'"
    >
      <g>
        <circle class="play-pause__circle" cx="24" cy="24" r="24"></circle>
        <polygon points="33.32 24 18.75 15.59 18.75 32.41 33.32 24"></polygon>
      </g>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="40"
      height="40"
      viewBox="0 0 24 27"
      v-if="icon === 'arrow'"
    >
      <path
        d="M16.767 13.647c.31.293.31.768 0 1.062-.31.293-.813.293-1.123 0l-4.495-4.249c-.31-.293-.31-.769 0-1.062.31-.294.813-.294 1.124 0l4.494 4.249z"
      ></path>
      <path
        d="M15.644 13.647c.31-.294.813-.294 1.123 0 .31.293.31.768 0 1.062l-4.494 4.249c-.31.293-.814.293-1.124 0-.31-.294-.31-.77 0-1.063l4.495-4.248z"
      ></path>
      <path
        d="M15.939 13.427c.329 0 .596.336.596.75 0 .416-.267.752-.596.752H7.596c-.33 0-.596-.336-.596-.751s.267-.751.596-.751h8.343z"
      ></path>
    </svg>
    <svg
      v-if="icon === 'close'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <path
        d="M10.473 12.76c-.63-.631-.63-1.655 0-2.287.632-.63 1.655-.63 2.287 0L29.526 27.24c.632.632.632 1.655 0 2.287-.63.63-1.654.63-2.286 0L10.473 12.76z"
      />
      <path
        d="M12.76 29.526c-.631.632-1.655.632-2.287 0-.63-.63-.63-1.654 0-2.286L27.24 10.473c.632-.63 1.655-.63 2.287 0 .63.632.63 1.655 0 2.287L12.76 29.526z"
      />
    </svg>
    <svg
      v-if="icon === 'chevron-down'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 12.8 22.7"
    >
      <path
        class="st0"
        d="M2.7,22.2c-0.6,0.6-1.6,0.6-2.2,0c-0.6-0.6-0.6-1.6,0-2.2l7.7-8c0.4-0.4,0.4-1,0-1.4l-7.7-8
      c-0.6-0.6-0.6-1.6,0-2.2c0.6-0.6,1.6-0.6,2.3,0L12,10c0.8,0.8,0.8,2,0,2.8C12,12.8,2.7,22.2,2.7,22.2z"
      ></path>
    </svg>
    <svg
      v-if="icon === 'search'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#283455"
        stroke-linecap="square"
        stroke-width="1.5"
        d="M14.324 14.546l4.859 4.86M14.3 7.805c1.78 1.78 1.76 4.738-.11 6.608-1.869 1.87-4.827 1.89-6.607.11-1.78-1.78-1.76-4.739.11-6.608 1.869-1.87 4.827-1.89 6.607-.11z"
      />
    </svg>
    <svg
      v-if="icon === 'tooltip'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#283455"
        d="M7.973 5.528c.372 0 .66-.3.66-.648 0-.384-.288-.672-.66-.672-.36 0-.648.288-.648.672 0 .348.288.648.648.648zm-.42 6.708c0 .144.12.264.264.264h.36c.132 0 .264-.12.264-.264V7.22c0-.132-.132-.264-.264-.264h-.36c-.144 0-.264.132-.264.264v5.016z"
      ></path>
      <circle cx="8" cy="8.5" r="7.5" stroke="#283455"></circle>
    </svg>
    <svg
      v-if="icon === 'splide-arrow'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width="40"
      height="40"
      focusable="false"
    >
      <path
        d="M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z"
      ></path>
    </svg>
    <svg
      v-if="icon === 'checkmark'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M0.191884 6.43781C-0.0652019 6.17755 -0.0637633 5.75849 0.195104 5.5C0.454702 5.24078 0.875198 5.24078 1.1348 5.5L4.02052 8.38157C4.41093 8.77141 4.67814 9.03587 5.06854 8.64603L12.523 0.194451C12.7826 -0.0648172 13.2032 -0.0648169 13.4628 0.194451C13.7217 0.452928 13.7232 0.871931 13.4662 1.13226L5.78649 9.85386C5.00358 10.647 4.08861 10.3827 3.30544 9.58987L0.191884 6.43781Z"
        fill="#283455"
      />
    </svg>
    <svg
      v-if="icon === 'clock'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6278 12C19.4628 12.0007 19.3049 12.0668 19.1886 12.1839C19.0725 12.3009 19.0076 12.4593 19.0081 12.6244C19.0088 12.9664 19.2856 13.2437 19.6278 13.2451H20.2339V14.0796C17.2232 14.8979 15 17.6534 15 20.9158C15 24.8207 18.1844 28 22.0926 28C26.0008 28 29.1817 24.8208 29.1817 20.9158C29.1817 17.6537 26.9617 14.8983 23.9526 14.0796L23.9524 13.2451H24.5587C24.9007 13.2437 25.1775 12.9664 25.1782 12.6244C25.1787 12.4593 25.1138 12.3009 24.9977 12.1839C24.8815 12.0668 24.7236 12.0007 24.5587 12H19.6278ZM21.4729 13.245H22.7083V13.8597C22.5054 13.842 22.2998 13.8317 22.0924 13.8317C21.8835 13.8317 21.6774 13.8418 21.473 13.8597L21.4729 13.245ZM22.0926 15.0768C25.3292 15.0768 27.9378 17.6841 27.9378 20.9158C27.9378 24.1475 25.3293 26.7561 22.0926 26.7561C18.8559 26.7561 16.2439 24.1476 16.2439 20.9158C16.2439 17.684 18.856 15.0768 22.0926 15.0768ZM22.0282 16.481C21.8634 16.4803 21.7048 16.5452 21.5877 16.6615C21.4705 16.7776 21.4044 16.9355 21.4039 17.1005V21.4758C21.4041 21.641 21.4702 21.7993 21.5873 21.9157C21.7044 22.0322 21.863 22.0972 22.0281 22.0965H24.5633C24.7283 22.0972 24.8869 22.0322 25.0041 21.9157C25.1212 21.7993 25.1873 21.641 25.1877 21.4758C25.1882 21.3101 25.1226 21.1508 25.0054 21.0337C24.8881 20.9164 24.729 20.8508 24.5633 20.8515H22.6489V17.1005C22.6475 16.7584 22.3705 16.4817 22.0282 16.481Z"
        fill="#283455"
      />
      <circle
        class="track"
        cx="21.5"
        cy="21.5"
        r="18.5"
        stroke="#283455"
        stroke-width="5"
      />
      <circle
        class="progress"
        cx="21.5"
        cy="21.5"
        r="18.5"
        stroke="#DDE3EC"
        stroke-width="5"
      />
    </svg>
    <svg
      v-if="icon === 'star'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.564888L8.83306 4.27908L8.89123 4.39694L9.0213 4.41584L13.1202 5.01144L10.1542 7.90254L10.0601 7.99428L10.0823 8.12382L10.7825 12.2061L7.11634 10.2787L7 10.2176L6.88366 10.2787L3.21754 12.2061L3.9177 8.12382L3.93992 7.99428L3.8458 7.90254L0.879844 5.01144L4.9787 4.41584L5.10877 4.39694L5.16694 4.27908L7 0.564888Z"
        stroke-width="0.5"
      />
    </svg>
    <svg
      v-if="icon === 'savings-shipping'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <circle cx="13" cy="13" r="12.5" stroke="#777777" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.48529 8C5.21727 8 5 8.21727 5 8.48529V16.6587C5 16.9267 5.21727 17.144 5.48529 17.144H7.27939C7.58874 17.8792 8.31591 18.3955 9.16366 18.3955C10.0114 18.3955 10.7386 17.8792 11.0479 17.144H16.1107C16.3526 17.144 16.5532 16.9669 16.59 16.7353H16.7369C16.9163 17.6807 17.7469 18.3955 18.7444 18.3955C19.742 18.3955 20.5726 17.6807 20.7519 16.7353H21.0147C21.2827 16.7353 21.5 16.518 21.5 16.25V13.5495C21.5 13.4953 21.4909 13.4412 21.4731 13.39L20.9162 11.7864C20.9122 11.7748 20.9077 11.7633 20.9028 11.7521C20.6609 11.196 20.4015 10.7129 19.9764 10.3887C19.5364 10.0532 18.9936 9.94118 18.3098 9.94118H16.596V8.48529C16.596 8.21727 16.3787 8 16.1107 8H5.48529ZM16.7036 16.25C16.7028 16.2669 16.7021 16.2839 16.7017 16.301C16.7013 16.284 16.7011 16.267 16.7011 16.25H16.7036ZM16.7868 15.7647C17.0392 14.9225 17.8201 14.3088 18.7444 14.3088C19.4795 14.3088 20.1239 14.6969 20.4839 15.2794H20.5431L20.5294 15.2545V13.6311L20.0055 12.1225C19.7737 11.5924 19.597 11.32 19.3879 11.1605C19.1914 11.0107 18.8989 10.9118 18.3098 10.9118H16.6471V15.7647H16.7868ZM20.7853 16.25H20.7878C20.7878 16.267 20.7876 16.284 20.7871 16.301C20.7867 16.2839 20.7861 16.2669 20.7853 16.25ZM7.42647 15.2758C7.2408 15.5748 7.13018 15.9253 7.12095 16.301C7.12053 16.284 7.12032 16.2669 7.12032 16.2498C7.12032 16.2242 7.12079 16.1987 7.12172 16.1734H5.97059V8.97059H15.6254V16.1734H14.2206V11.3971C14.2206 11.129 14.0033 10.9118 13.7353 10.9118C13.4673 10.9118 13.25 11.129 13.25 11.3971V16.1734H11.3088L11.3088 11.3971C11.3088 11.129 11.0915 10.9118 10.8235 10.9118C10.5555 10.9118 10.3382 11.129 10.3382 11.3971V14.6799C10.006 14.4461 9.60084 14.3088 9.16366 14.3088C8.89256 14.3088 8.63378 14.3616 8.39706 14.4575L8.39706 11.3971C8.39706 11.129 8.17979 10.9118 7.91176 10.9118C7.64374 10.9118 7.42647 11.129 7.42647 11.3971L7.42647 15.2758ZM11.2045 16.25H11.207C11.207 16.267 11.2068 16.284 11.2064 16.301C11.206 16.2839 11.2053 16.2669 11.2045 16.25ZM9.16366 17.4249C9.75613 17.4249 10.2364 16.9446 10.2364 16.3522C10.2364 15.7597 9.75613 15.2794 9.16366 15.2794C8.5712 15.2794 8.09091 15.7597 8.09091 16.3522C8.09091 16.9446 8.5712 17.4249 9.16366 17.4249ZM18.7444 17.4249C19.3369 17.4249 19.8172 16.9446 19.8172 16.3522C19.8172 15.7597 19.3369 15.2794 18.7444 15.2794C18.152 15.2794 17.6717 15.7597 17.6717 16.3522C17.6717 16.9446 18.152 17.4249 18.7444 17.4249Z"
          fill="#777777"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'savings-tote'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <circle cx="13" cy="13" r="12.5" stroke="#777777" />
      </g>
      <g opacity="0.6">
        <path
          d="M10.7087 11.9209C10.4234 11.9209 10.1921 12.1522 10.1921 12.4375C10.1921 12.7229 10.4234 12.9542 10.7087 12.9542H15.2921C15.5774 12.9542 15.8087 12.7229 15.8087 12.4375C15.8087 12.1522 15.5774 11.9209 15.2921 11.9209H10.7087Z"
          fill="#777777"
        />
        <path
          d="M10.7087 13.8305C10.4234 13.8305 10.1921 14.0619 10.1921 14.3472C10.1921 14.6326 10.4234 14.8639 10.7087 14.8639H15.2921C15.5774 14.8639 15.8087 14.6326 15.8087 14.3472C15.8087 14.0619 15.5774 13.8305 15.2921 13.8305H10.7087Z"
          fill="#777777"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.8062 3.90002C12.1248 3.90002 11.5568 4.03222 11.1217 4.36188C10.6803 4.69638 10.4537 5.17465 10.3344 5.69975C10.217 6.21633 10.1921 6.82854 10.1921 7.49286C10.1921 7.80691 10.1978 8.14303 10.2038 8.49356L10.2051 8.56601C10.2088 8.78625 10.2126 9.01317 10.2151 9.24725H8.41706C8.13171 9.24725 7.90039 9.47857 7.90039 9.76391V19.6945C7.90039 19.9798 8.13171 20.2111 8.41706 20.2111H17.5837C17.8691 20.2111 18.1004 19.9798 18.1004 19.6945V9.76391C18.1004 9.47857 17.8691 9.24725 17.5837 9.24725H15.8086C15.8078 8.31943 15.8028 7.55225 15.7691 6.92672C15.7299 6.19794 15.6498 5.60064 15.4588 5.13842C15.2527 4.6396 14.919 4.3024 14.4304 4.11262C13.9838 3.93919 13.433 3.90002 12.8062 3.90002ZM11.7458 5.18547C11.9323 5.04418 12.2447 4.93336 12.8062 4.93336C13.4224 4.93336 13.8037 4.97777 14.0563 5.07585C14.165 5.11807 14.2496 5.1701 14.3198 5.24023C14.3902 5.31063 14.4503 5.40352 14.5038 5.53307C14.6235 5.82275 14.6989 6.26977 14.7373 6.98234C14.7694 7.57877 14.7745 8.31883 14.7752 9.24725L11.2484 9.24725C11.2459 9.00522 11.2421 8.77196 11.2383 8.54835L11.2371 8.47804C11.231 8.12459 11.2254 7.79768 11.2254 7.49286C11.2254 6.83551 11.2523 6.32363 11.342 5.92877C11.4298 5.54258 11.5657 5.32197 11.7458 5.18547ZM8.93372 19.1778L8.93372 10.2806L17.0671 10.2806L17.0671 19.1778H8.93372Z"
          fill="#777777"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'savings-gift'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <circle cx="13" cy="13" r="12.5" stroke="#777777" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.9999 7.71867C12.6498 6.98943 12.1604 6.49611 11.6293 6.22907C11.1872 6.00678 10.711 5.94189 10.2842 6.05367C9.85024 6.16731 9.47456 6.46546 9.29451 6.9277C8.97503 7.74789 9.31195 8.54297 9.93115 9.09831H7.46154C7.20664 9.09831 7 9.30495 7 9.55985V11.406C7 11.6609 7.20664 11.8675 7.46154 11.8675H7.92308L7.92308 18.7909C7.92308 19.0458 8.12972 19.2524 8.38462 19.2524H17.6154C17.8703 19.2524 18.0769 19.0458 18.0769 18.7909L18.0769 11.8675H18.5385C18.7934 11.8675 19 11.6609 19 11.406V9.55985C19 9.30495 18.7934 9.09831 18.5385 9.09831H16.0687C16.6879 8.54297 17.0248 7.74789 16.7053 6.9277C16.5253 6.46546 16.1496 6.16731 15.7157 6.05367C15.2888 5.94189 14.8127 6.00678 14.3706 6.22907C13.8394 6.49611 13.35 6.98943 12.9999 7.71867ZM10.1358 7.25348C10.1906 7.11286 10.3034 7.00858 10.4812 6.96202C10.6661 6.9136 10.9249 6.93073 11.2108 7.07447C11.6957 7.31825 12.2484 7.93074 12.4967 9.09826H12.2338C11.5371 8.99327 10.9846 8.74666 10.6147 8.44665C10.1048 8.03303 10.0039 7.5923 10.1358 7.25348ZM11.6154 10.0214H7.92308L7.92308 10.9445H11.6154V10.0214ZM11.6154 11.8675H8.84615L8.84615 18.3293H11.6154V11.8675ZM14.3846 18.3293H17.1538V11.8675H14.3846V18.3293ZM14.3846 10.9445H18.0769V10.0214H14.3846V10.9445ZM13.7661 9.09826C14.4627 8.99327 15.0153 8.74666 15.3851 8.44665C15.8951 8.03303 15.996 7.5923 15.864 7.25348C15.8092 7.11286 15.6965 7.00858 15.5187 6.96202C15.3338 6.9136 15.0749 6.93073 14.789 7.07447C14.3042 7.31825 13.7515 7.93074 13.5031 9.09826H13.7661ZM13.2407 10.0873L13.4615 10.0846V18.329H12.5385V10.0846L12.7591 10.0873C12.8385 10.0898 12.9188 10.0908 12.9999 10.0902C13.081 10.0908 13.1613 10.0898 13.2407 10.0873Z"
          fill="#777777"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'check--goldenhour'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <circle cx="13" cy="13" r="13" fill="#E3AD7C" />
      <path
        d="M9 13.4462L12.1111 16.4L17 10"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-if="icon === 'sparkle'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g opacity="0.8">
        <path
          d="M14 6C14 5.89282 13.9252 5.79676 13.8122 5.7592C11.0095 4.82318 10.4825 4.09803 9.78576 0.216752C9.76342 0.0918688 9.64214 0 9.5 0C9.35773 0 9.23658 0.0918688 9.21424 0.216752C8.51738 4.09821 7.99041 4.82336 5.18777 5.7592C5.07484 5.79688 5 5.89282 5 6C5 6.10718 5.07484 6.20324 5.18777 6.2408C7.99048 7.17694 8.51745 7.90222 9.21424 11.7832C9.23658 11.9081 9.35786 12 9.5 12C9.64228 12 9.76342 11.9081 9.78576 11.7832C10.4826 7.90179 11.0096 7.17694 13.8122 6.2408C13.9252 6.20312 14 6.10718 14 6Z"
          fill="#508334"
        />
        <path
          d="M6 11.5C6 11.4375 5.95011 11.3814 5.87482 11.3595C4.00635 10.8135 3.65503 10.3905 3.19051 8.12644C3.17561 8.05359 3.09476 8 3 8C2.90515 8 2.82439 8.05359 2.80949 8.12644C2.34492 10.3906 1.99361 10.8136 0.125181 11.3595C0.0498936 11.3815 0 11.4375 0 11.5C0 11.5625 0.0498936 11.6186 0.125181 11.6405C1.99365 12.1865 2.34497 12.6096 2.80949 14.8736C2.82439 14.9464 2.90524 15 3 15C3.09485 15 3.17561 14.9464 3.19051 14.8736C3.65508 12.6094 4.00639 12.1865 5.87482 11.6405C5.95011 11.6185 6 11.5625 6 11.5Z"
          fill="#508334"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'video-play'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g id="Vector">
        <path
          d="M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z"
          fill="white"
        />
        <path
          d="M26.55 17.55L12.375 25.7339L12.375 9.36606L26.55 17.55Z"
          fill="#283455"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'video-pause'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g id="Group 3437">
        <circle id="Ellipse 154" cx="18" cy="18" r="18" fill="white" />
        <g id="pause button">
          <path
            id="Line 162 (Stroke)"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 26L12 9L16.0182 9L16.0182 26L12 26Z"
            fill="#283455"
          />
          <path
            id="Line 163 (Stroke)"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.3455 26L20.3455 9L24.3636 9L24.3636 26L20.3455 26Z"
            fill="#283455"
          />
        </g>
      </g>
    </svg>
    <svg
      v-if="icon === 'free-shipping'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="12"
      viewBox="0 0 27 12"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.9853 0.850098C9.63444 0.850098 9.35001 1.13453 9.35001 1.48539V9.65877C9.35001 10.0096 9.63444 10.2941 9.9853 10.2941H11.6823C12.0345 11.0339 12.7892 11.5456 13.6637 11.5456C14.5381 11.5456 15.2928 11.0339 15.645 10.2941H20.6107C20.8368 10.2941 21.0352 10.176 21.1478 9.99816C21.4235 10.8943 22.2578 11.5456 23.2444 11.5456C24.272 11.5456 25.1343 10.8391 25.3725 9.88539H25.5147C25.8656 9.88539 26.15 9.60096 26.15 9.2501V6.54959C26.15 6.47871 26.1381 6.40801 26.1148 6.34091L25.558 4.73733C25.5527 4.72211 25.5468 4.7071 25.5404 4.69231C25.2974 4.13384 25.0255 3.61886 24.5673 3.26953C24.0897 2.9053 23.5082 2.79127 22.8098 2.79127H21.246V1.48539C21.246 1.13453 20.9615 0.850098 20.6107 0.850098H9.9853ZM11.7765 8.23394C11.6352 8.47183 11.5376 8.73875 11.4948 9.02347H10.6206V2.12069H19.9754V9.02347H18.8706V4.39716C18.8706 4.04629 18.5862 3.76186 18.2353 3.76186C17.8844 3.76186 17.6 4.04629 17.6 4.39716V9.02347H15.9588V4.39716C15.9588 4.04629 15.6744 3.76186 15.3235 3.76186C14.9727 3.76186 14.6882 4.04629 14.6882 4.39716V7.41247C14.3824 7.2506 14.0336 7.15892 13.6637 7.15892C13.4497 7.15892 13.2428 7.18959 13.0471 7.24682V4.39716C13.0471 4.04629 12.7626 3.76186 12.4118 3.76186C12.0609 3.76186 11.7765 4.04629 11.7765 4.39716L11.7765 8.23394ZM24.8794 6.65651V7.89021C24.4779 7.44156 23.8942 7.15892 23.2444 7.15892C22.3972 7.15892 21.6624 7.63921 21.2971 8.34216V4.06186H22.8098C23.3842 4.06186 23.6381 4.15879 23.7969 4.2799C23.9726 4.41381 24.1362 4.65329 24.3657 5.17738L24.8794 6.65651ZM12.7409 9.35226C12.7409 8.84264 13.154 8.42951 13.6637 8.42951C14.1733 8.42951 14.5864 8.84264 14.5864 9.35226C14.5864 9.86189 14.1733 10.275 13.6637 10.275C13.154 10.275 12.7409 9.86189 12.7409 9.35226ZM22.3217 9.35226C22.3217 8.84264 22.7348 8.42951 23.2444 8.42951C23.7541 8.42951 24.1672 8.84264 24.1672 9.35226C24.1672 9.86189 23.7541 10.275 23.2444 10.275C22.7348 10.275 22.3217 9.86189 22.3217 9.35226ZM7 4.50012C7 4.77626 6.77614 5.00012 6.5 5.00012L2.5 5.00012C2.22386 5.00012 2 4.77626 2 4.50012C2 4.22398 2.22386 4.00012 2.5 4.00012L6.5 4.00012C6.77614 4.00012 7 4.22398 7 4.50012ZM6.5 8.00012C6.77614 8.00012 7 7.77626 7 7.50012C7 7.22398 6.77614 7.00012 6.5 7.00012L0.5 7.00012C0.223857 7.00012 0 7.22398 0 7.50012C0 7.77626 0.223857 8.00012 0.5 8.00012L6.5 8.00012Z"
        fill="#283455"
      />
    </svg>
    <svg
      v-if="icon === 'check-background'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <circle cx="6" cy="6" r="6" fill="#4E8033" />
      <path
        d="M8.3642 3.93513L8.36392 3.93484L8.35525 3.94412L5.08536 7.44435C5.07462 7.45411 5.06674 7.45978 5.06166 7.46298C5.05245 7.45841 5.03662 7.44871 5.01198 7.42883C4.98134 7.40411 4.9477 7.37261 4.90343 7.33088L3.63572 6.1357C3.44463 5.95554 3.1396 5.95554 2.94851 6.1357C2.75151 6.32143 2.7503 6.62762 2.9461 6.81477L4.3139 8.12215C4.5032 8.30308 4.72604 8.44133 4.96805 8.47687C5.22037 8.51393 5.4674 8.4352 5.68027 8.23159L5.6805 8.23183L5.6883 8.22347L9.05863 4.60968C9.24968 4.42211 9.24689 4.11936 9.05148 3.93513L8.91428 4.08065L9.05148 3.93513C8.86037 3.75496 8.55531 3.75496 8.3642 3.93513Z"
        fill="white"
        stroke="white"
        stroke-width="0.4"
      />
    </svg>
    <svg
      v-if="icon === 'qv-plus'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="12"
      height="12"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.635254 3.77237C0.635254 3.49758 0.858018 3.27481 1.13281 3.27481H6.77179C7.04658 3.27481 7.26935 3.49758 7.26935 3.77237C7.26935 4.04716 7.04658 4.26993 6.77179 4.26993H1.13281C0.858018 4.26993 0.635254 4.04716 0.635254 3.77237Z"
        fill="#293C70"
      />
      <path
        d="M3.9523 7.08942C3.67751 7.08942 3.45474 6.86665 3.45474 6.59186V0.952883C3.45474 0.67809 3.67751 0.455326 3.9523 0.455326C4.22709 0.455326 4.44986 0.67809 4.44986 0.952883V6.59186C4.44986 6.86665 4.22709 7.08942 3.9523 7.08942Z"
        fill="#293C70"
      />
    </svg>
    <svg
      v-if="icon === 'price-tag'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <rect width="34" height="34" rx="17" class="backdrop" />
      <path
        d="M15.1867 28.4139C16.0269 29.2541 17.3891 29.2541 18.2293 28.4139L24.5833 22.0599C25.4236 21.2197 25.4236 19.8574 24.5833 19.0172L16.9702 11.404C16.5312 10.9651 15.9241 10.7371 15.3047 10.7787L9.61689 11.1605C8.57425 11.2305 7.73267 12.0395 7.62166 13.0786L6.98089 19.0762C6.91179 19.7229 7.13897 20.3662 7.59887 20.8261L15.1867 28.4139Z"
        stroke-width="1.30769"
        class="tag"
      />
      <circle
        cx="13.7424"
        cy="17.5336"
        r="2.24648"
        transform="rotate(180 13.7424 17.5336)"
        stroke-width="1.30769"
        class="tag-cutout"
      />
      <path
        d="M9.81682 17.6568L10.4634 17.7258L9.81682 17.6568C9.74773 18.3035 9.9749 18.9468 10.4348 19.4067L18.0226 26.9945C18.8628 27.8347 20.2251 27.8347 21.0653 26.9945L27.4193 20.6405C28.2595 19.8003 28.2595 18.438 27.4193 17.5978L19.8061 9.98459C19.3671 9.54565 18.76 9.31769 18.1407 9.35926L12.4528 9.74105C11.4102 9.81104 10.5686 10.6201 10.4576 11.6592L9.81682 17.6568Z"
        stroke-width="1.30769"
        class="tag"
      />
      <circle
        cx="16.5725"
        cy="16.1337"
        r="2.24648"
        transform="rotate(180 16.5725 16.1337)"
        stroke-width="1.30769"
        class="tag-cutout"
      />
      <path
        d="M12.6489 16.2456L13.2954 16.3147L12.6489 16.2456C12.5798 16.8924 12.8069 17.5356 13.2668 17.9955L20.8546 25.5833C21.6948 26.4235 23.0571 26.4235 23.8973 25.5833L27.0743 22.4063L30.2513 19.2293C31.0915 18.3891 31.0915 17.0269 30.2513 16.1867L22.6381 8.57346C22.1992 8.13452 21.592 7.90655 20.9727 7.94813L15.2849 8.32992C14.2422 8.39991 13.4006 9.20896 13.2896 10.248L12.6489 16.2456Z"
        stroke-width="1.30769"
        class="tag"
      />
      <circle
        cx="19.5084"
        cy="14.8359"
        r="2.24648"
        transform="rotate(180 19.5084 14.8359)"
        stroke-width="1.30769"
        class="tag-cutout"
      />
    </svg>
    <svg
      v-if="icon === 'pencil-chat-bubble'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="295"
      height="36"
      viewBox="0 0 295 36"
      fill="none"
    >
      <path
        d="M288 1H7C3.68629 1 1 3.68629 1 7V20.5C1 23.8137 3.6863 26.5 7.00001 26.5H231.986L236.818 34.5675C237.206 35.2157 238.145 35.2157 238.534 34.5675L243.365 26.5H288C291.314 26.5 294 23.8137 294 20.5V7C294 3.68629 291.314 1 288 1Z"
        fill="white"
        stroke="#283455"
        stroke-linecap="round"
      />
      <text x="28" y="18" class="p5" fill="black">{{ props?.content }}</text>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.3035 8.13792C15.8157 7.1326 16.9811 6.6468 18.0557 6.99071C19.4405 7.4339 20.0724 9.03425 19.3639 10.304L16.6846 15.106C16.1925 15.988 15.5101 16.7492 14.6871 17.3346L13.4803 18.1929C13.0618 18.4905 12.4752 18.3153 12.2884 17.8371C11.7567 16.4758 11.832 14.9522 12.4954 13.65L15.3035 8.13792ZM17.7508 7.94312C17.1432 7.74864 16.4842 8.02336 16.1945 8.59185L13.3865 14.1039C12.8941 15.0703 12.8043 16.1883 13.1289 17.2156L14.1075 16.5197C14.8095 16.0204 15.3916 15.371 15.8113 14.6188L18.4906 9.81672C18.8913 9.09872 18.5339 8.19374 17.7508 7.94312Z"
        fill="#283455"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4295 15H12.4999V14H13.4295C14.2654 14 15.046 14.4178 15.5097 15.1132L15.9159 15.7227L15.0839 16.2774L14.6776 15.668C14.3994 15.2507 13.9311 15 13.4295 15Z"
        fill="#283455"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6783 8.80706C15.7849 8.62947 16.0152 8.57189 16.1928 8.67844L18.6928 10.1784C18.8704 10.285 18.928 10.5153 18.8215 10.6929C18.7149 10.8705 18.4846 10.9281 18.307 10.8216L15.807 9.32156C15.6294 9.215 15.5718 8.98466 15.6783 8.80706Z"
        fill="#283455"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6783 9.80706C14.7849 9.62947 15.0152 9.57189 15.1928 9.67844L17.6928 11.1784C17.8704 11.285 17.928 11.5153 17.8215 11.6929C17.7149 11.8705 17.4846 11.9281 17.307 11.8216L14.807 10.3216C14.6294 10.215 14.5718 9.98466 14.6783 9.80706Z"
        fill="#283455"
      />
    </svg>
    <svg
      v-if="icon === 'input-sliders'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 3242">
        <path
          id="Line 116"
          d="M4 16.5L20 16.5"
          stroke="#283455"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          id="Line 119"
          d="M16 14.5L16 18.5"
          stroke="#283455"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <path
          id="Line 120"
          d="M4 8.5L20 8.5"
          stroke="#283455"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          id="Line 121"
          d="M8 6.5L8 10.5"
          stroke="#283455"
          stroke-width="2.5"
          stroke-linecap="round"
        />
      </g>
    </svg>
    <svg
      v-if="icon === 'bookend-arrow'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="39"
      viewBox="0 0 24 39"
      fill="none"
    >
      <rect
        width="24"
        height="39"
        transform="translate(24 39)"
        fill="#FDFAF8"
      />
      <path
        d="M16.8761 26.7353C16.4632 27.1548 15.786 27.1524 15.376 26.7301C14.9809 26.3231 14.9809 25.6758 15.376 25.2689L20.3003 20.1966C20.6769 19.8086 20.6769 19.1914 20.3003 18.8034L15.3761 13.7313C14.9809 13.3242 14.9809 12.6768 15.3761 12.2698C15.7861 11.8475 16.4632 11.845 16.8762 12.2644L22.6182 18.0944C23.3848 18.8727 23.385 20.1222 22.6187 20.9007L16.8761 26.7353Z"
        fill="#283455"
      />
    </svg>
    <svg
      v-if="icon === 'rewards-badge'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="65"
      height="67"
      viewBox="0 0 65 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#a)" fill="#283455">
        <path
          d="M44.827 37.936a.4.4 0 0 1-.378.29.4.4 0 0 1-.122-.02l-1.073-.36c-1.488 4.284-5.666 7.152-10.455 7.152-4.79 0-8.945-2.857-10.443-7.114l-.965.324a.4.4 0 0 1-.121.02.4.4 0 0 1-.38-.29.42.42 0 0 1 .258-.523l2.717-.91a.393.393 0 0 1 .5.27.417.417 0 0 1-.257.522l-.997.333c1.394 3.915 5.276 6.537 9.683 6.537s8.315-2.633 9.698-6.573l-.89-.297a.417.417 0 0 1-.256-.523.395.395 0 0 1 .5-.27l2.718.911c.21.07.325.304.256.523zM30.656 23.32c-.207-.68-.952-.994-1.569-.805-.657.201-1.12.88-.947 1.575.181.712.954 1.083 1.635.866.602-.192 1.107-.888.883-1.634zm-.95 1.465c-.375.127-.529-.548-.644-.992-.109-.415-.312-1.005.055-1.121.333-.105.498.527.615.947.12.428.359 1.038-.026 1.166m-1.996-.694c-.372-.596-1.17-.692-1.719-.34-.582.378-.856 1.162-.514 1.783.356.637 1.195.777 1.795.38.531-.353.84-1.166.435-1.823zm-.543 1.678c-.329.227-.65-.382-.873-.778-.209-.37-.555-.88-.233-1.094.295-.194.613.369.833.742.226.38.61.902.273 1.13m8.643-5.3-.586 4.1-.89-.138.52-3.634c.129-.036.259-.076.379-.116.22-.067.514-.19.58-.212zm1.355.711c-.62-.19-.892.785-.276.974.617.19.893-.784.276-.973m-.5 1.468c-.12.013-.256.022-.382.031l-.149.527q-.014.055-.03.105l-.39 1.387h-.005l-.004.016.864.266.673-2.381c-.069.011-.35.024-.576.047zm5.045 2.411c-.46-.36-1.228-.258-1.672.343-.392.534-.25 1.32.265 1.715.516.398 1.04.188 1.04.188l.134-.19s-.197.092-.463-.114c-.715-.554-.186-1.304-.186-1.304l1.067.824.081-.107c.34-.482.143-1.043-.265-1.356zm-.11.73-.14.2-.538-.415s.386-.62.693-.384c.248.192.073.467-.015.599m-2.283-.253c-.122.275-.16.431-.08.52.063.06.154.099.154.099l-.064.143-.57-.277c-.337-.166-.46-.371-.236-.874l.375-.846c.032-.072.235-.422-.025-.55-.188-.091-.333.092-.41.262l-.68 1.532-.816-.398.548-1.232c.013-.03.032-.065.045-.103l.263-.594c.132.002.821.038.892.033l-.152.342.064-.022c.271-.103.495-.123.743.018.341.194.54.618.375.987zm4.597 3.254-.837.597c-.239.172-.35.285-.324.406a.6.6 0 0 0 .083.165l-.123.088-.355-.543c-.209-.324-.215-.565.222-.878l.739-.525c.061-.044.407-.239.245-.487-.117-.178-.33-.1-.478.005l-1.336.951-.506-.777 1.074-.766c.023-.018.057-.038.09-.065l.516-.368c.113.073.687.471.751.507l-.299.212.066.015c.282.056.485.16.63.414.198.35.162.82-.16 1.05zM32.923 24.47l1.118-.03-.87-1.222c.475-.259.522-.462.518-.708-.013-.603-.647-.607-.9-.552-.227.047-.492.19-.603.255l-.04-1.87c-.062.039-.327.213-.538.322-.111.06-.243.125-.363.184l.081 3.655.914-.022-.024-1.13.017.027.692 1.087zm-.715-1.299-.015-.723c.102-.06.151-.105.252-.128.217-.049.367.027.358.302-.015.482-.595.55-.595.55M25.62 27.14l-.69.621-1.003-1.22c-.098-.117-.188-.23-.256-.314-.128-.132-.222-.18-.293-.145-.032.022-.096.058-.123.082l-.026.023-.098-.119.476-.428c.22-.197.401-.266.631-.094l-.004-.043c-.028-.227.004-.448.165-.6.149-.139.388-.148.518.01a.36.36 0 0 1-.019.477c-.122.125-.365.03-.444.107-.053.047-.026.2.094.346l1.073 1.3zm-1.904.189c-.557-.54-1.09-.55-1.417-.242-.474.45-.361 1.037-.361 1.037l-1.101-.867-.073-.047c-.26-.116-.456.036-.63.277l-.377.525.12.094.019-.027c.02-.031.076-.078.102-.107.06-.05.156-.025.297.062.198.159 1.613 1.287 1.906 1.517.582.458 1.056.402 1.547-.277.653-.91.369-1.555-.034-1.943zm-.118 1.768c-.158.237-.28.114-.28.114l-1.222-.964c.032-.548.41-.713 1.005-.262.32.24.758.728.497 1.113m9.174 29.837 1.3-.056-.726-1.746zM14.701 15.153c-.26-.254-.61-.223-.907.107l-.429.483.873.853.444-.498c.288-.322.275-.692.02-.945m5.803 38.387-.677-.446-.691 1.148.676.446c.36.24.739.177.946-.167.213-.355.106-.742-.254-.98m-2.29-41.395c-.242-.335-.626-.368-.967-.1l-.64.502.778 1.086.64-.503c.342-.268.421-.659.189-.985m9.017-1.654c.685-.167 1.214-.842.99-1.847s-.984-1.36-1.67-1.19c-.684.167-1.216.837-.99 1.842.227 1.005.985 1.365 1.672 1.197zm-4.579 1.688c.636-.32 1.011-1.097.584-2.028s-1.24-1.106-1.876-.786-1.013 1.092-.587 2.023c.427.931 1.243 1.11 1.879.79m-7.578 4.161-.51.572.892.873.495-.554c.288-.321.313-.71.044-.974-.264-.259-.608-.265-.921.085z"
        />
        <path
          d="M32.392 0C14.712 0 .379 15 .379 33.5S14.712 67 32.392 67s32.012-15 32.012-33.5S50.071 0 32.392 0m16.06 12.123-.282.413-1.447-1.079-.675.992 1.313.978-.286.417-1.313-.978-.672.987 1.447 1.08-.282.412-1.872-1.398 2.197-3.222zM41.81 8.125l.636.306.501 3.587 1.215-2.759.476.228-1.584 3.596-.495-.24-.566-3.825-1.289 2.933-.476-.228 1.584-3.596zm-2.653-.862.514.152-1.022 3.812-.514-.152zm-4.044-.802.518.076-.46 3.41 1.769.262-.069.509-2.288-.34.53-3.92zm-4.252-.094.058 2.037 1.712-2.093.687-.022-1.522 1.814 1.658 2.143-.661.02L31.46 8.51l-.52.619.034 1.194-.523.016-.114-3.957.523-.016zm-4.42.597c.925-.226 2.01.265 2.299 1.554.288 1.289-.476 2.238-1.4 2.465-.924.228-2.01-.27-2.299-1.558-.288-1.289.476-2.234 1.4-2.46zm-5.286 1.95c.856-.432 2.017-.197 2.563.998.547 1.194-.002 2.29-.858 2.722-.855.431-2.019.19-2.567-1.003-.546-1.192.004-2.287.86-2.718zm-4.112 2.68c.572-.45 1.227-.309 1.602.214.327.455.303 1.027-.09 1.474l1.674.759-.487.382-1.62-.753-.452.355.928 1.296-.422.332-2.27-3.166 1.139-.896zm-1.607 6.918-2.764-2.702.84-.943c.492-.551 1.091-.567 1.529-.14a.91.91 0 0 1 .211 1.016c.373-.255.826-.172 1.133.13.438.426.43 1.098-.045 1.627l-.902 1.012zm5.779 36.305c-.29.483-.809.661-1.349.438l-.083 1.905-.515-.34.094-1.851-.478-.315-.826 1.37-.446-.296 2.02-3.347 1.205.795c.604.4.71 1.09.378 1.643zm3.68.98-1.642-.714-.446 1.123 1.488.648-.188.473-1.488-.647-.444 1.119 1.642.714-.186.47-2.124-.925 1.454-3.656 2.123.924-.186.47zm4.56 4.62-.531-.097-.45-3.339-1.484 2.99-.514-.093-.434-4.096.532.096.316 3.203 1.44-2.886.542.098.448 3.261 1.315-2.941.532.096-1.706 3.71zm5.28.046-.455-1.088-1.673.074-.356 1.121-.56.025 1.345-4.022.602-.027 1.663 3.888-.566.025zm4.125-.761-1.182-1.38-.553.129.34 1.579-.515.12-.83-3.861 1.39-.326c.697-.165 1.24.245 1.376.884.12.556-.126 1.066-.66 1.307l1.228 1.411-.594.14zm3.592-1.282-1.206.54-1.49-3.64 1.217-.545c.884-.396 1.912-.11 2.401 1.087.487 1.19-.038 2.162-.922 2.557m4.221-2.272c-.761.525-1.444.261-1.799-.17l.331-.428c.263.346.728.516 1.204.187.437-.301.501-.685.318-.976-.15-.236-.435-.335-.796-.187l-.514.207c-.515.208-1.03.121-1.34-.373-.327-.518-.16-1.3.422-1.701.713-.492 1.289-.226 1.585.082l-.3.416a.746.746 0 0 0-1.025-.103c-.356.246-.459.663-.264.972.149.236.4.323.708.2l.54-.218c.602-.242 1.114-.099 1.404.361.323.514.199 1.269-.476 1.731zm-14.28-5.898c-8.839 0-16.006-7.5-16.006-16.75s7.167-16.75 16.007-16.75S48.4 24.25 48.4 33.5s-7.166 16.75-16.006 16.75m17.055-31.653-.378-.411.811-3.777-2.226 2.234-.363-.396 2.73-2.74.485.527-.788 3.529 2.094-2.102.362.396-2.73 2.74z"
        />
        <path
          d="m41.14 55.227-.722.324 1.125 2.747.71-.32c.643-.288.997-.98.624-1.896-.376-.918-1.095-1.143-1.738-.855m-2.781 1.74c-.087-.408-.424-.603-.84-.504l-.782.183.284 1.324.781-.183c.416-.098.643-.42.557-.817z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.379 0h64.025v67H.379z" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="icon === 'heart-sm'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M14.8271 8.1084C16.2394 6.63117 18.5194 6.63117 19.9316 8.1084C21.3558 9.59835 21.3559 12.0228 19.9316 13.5127L14.0713 19.6426C13.4806 20.2601 12.494 20.2602 11.9033 19.6426L6.06836 13.5371C4.64407 12.0472 4.64403 9.62273 6.06836 8.13281C7.48057 6.65566 9.76067 6.65561 11.1729 8.13281L12.627 9.6543L12.9883 10.0322L13.3496 9.6543L14.8271 8.1084Z"
        stroke="#777777"
      />
    </svg>
    <svg
      v-if="icon === 'heart-lg'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M14.8418 5.03125C16.8224 2.98944 20.0282 2.98944 22.0088 5.03125C23.9975 7.0816 23.9976 10.4126 22.0088 12.4629L13.5596 21.1719C12.9703 21.7793 11.9955 21.7793 11.4062 21.1719L5.2959 14.8721H5.29688L4.95898 14.5234L2.99121 12.4961C1.00236 10.4458 1.00247 7.1148 2.99121 5.06445C4.97185 3.02266 8.17757 3.02265 10.1582 5.06445L12.125 7.09277L12.4834 7.46289L12.8428 7.09277L14.8418 5.03125Z"
        stroke="#777777"
      />
    </svg>
    <svg
      v-if="icon === 'info-tooltip'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8.5"
        cy="8.5"
        r="7.893"
        stroke="#283455"
        stroke-width="1.214"
        fill="none"
      />
      <path
        d="M8.467 5.534a.793.793 0 0 1-.786-.787c0-.466.35-.816.786-.816.452 0 .802.35.802.816 0 .423-.35.787-.802.787m-.51 8.145V7.59c0-.16.146-.321.321-.321h.437c.16 0 .32.16.32.32v6.091c0 .175-.16.321-.32.321h-.437a.323.323 0 0 1-.32-.32"
        fill="#283455"
      />
    </svg>
    <svg
      v-if="icon === 'close-tooltip'"
      role="img"
      :aria-hidden="props.ariaHidden"
      :aria-label="props.ariaHidden ? null : icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.496 4.51a.712.712 0 0 0-1.007-1.006L8 6.993l-3.49-3.49a.712.712 0 0 0-1.006 1.008L6.993 8l-3.49 3.49a.712.712 0 0 0 1.008 1.006L8 9.008l3.49 3.49a.712.712 0 1 0 1.006-1.008L9.007 8z"
        fill="#283455"
      />
    </svg>
  </span>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  icon: { type: String, required: true },
  color: { type: String },
  content: { type: String, required: false },
  ariaHidden: {
    // Default is null to prevent aria attributes from being applied completely
    type: [Boolean, null],
    default: null,
    required: false,
  },
});

const className = computed(() => `icon--${props.icon}`);
</script>
